import ClusteredBarComboChart from '../assets/icons/chart/thumbnails/clustered-bar-combo-chart.svg';
import DonutChart from '../assets/icons/chart/thumbnails/donut-chart.svg';
import horizontalBarChart from '../assets/icons/chart/thumbnails/horizontal-bar-chart.svg';
import LineChart from '../assets/icons/chart/thumbnails/line-chart.svg';
import MetricChart from '../assets/icons/chart/thumbnails/metric-chart.svg';
import OtherChart from '../assets/icons/chart/thumbnails/other-chart.svg';
import PieChart from '../assets/icons/chart/thumbnails/pie-chart.svg';
import StackedHorizontalBarChart from '../assets/icons/chart/thumbnails/stacked-horizontal-bar-chart.svg';
import StackedVerticalBarChart from '../assets/icons/chart/thumbnails/stacked-vertical-bar-chart.svg';
import TableChart from '../assets/icons/chart/thumbnails/table-chart.svg';
import VerticalBarChart from '../assets/icons/chart/thumbnails/vertical-bar-chart.svg';

import NumberChart from '../assets/icons/chart/thumbnails/number-chart.svg';
import PivotChart from '../assets/icons/chart/thumbnails/pivot-table-chart.svg';
import ScatterChart from '../assets/icons/chart/thumbnails/scatter-chart.svg';
import HistogramChart from '../assets/icons/chart/thumbnails/histogram-chart.svg';
import TreemapChart from '../assets/icons/chart/thumbnails/treemap-chart.svg';
import HeatmapChart from '../assets/icons/chart/thumbnails/heatmap-chart.svg';
import StackedBarComboChart from '../assets/icons/chart/thumbnails/stackedbarcombo-chart.svg';
import FunnelChart from '../assets/icons/chart/thumbnails/funnel-chart.svg';


export default function ChartIcon({
  chartType
}) {
  switch (chartType) {
    case 'pie':
      return PieChart;
    case 'table':
      return TableChart;
    case 'bar':
      return VerticalBarChart;
    case 'donut':
      return DonutChart;
    case 'line':
      return LineChart;
    case 'horizontalBar':
      return horizontalBarChart;
    case 'area':
      return MetricChart;
    case 'clusteredBarCombo':
      return ClusteredBarComboChart;
    case 'horizontalStackedBarChart100':
      return StackedHorizontalBarChart;
    case 'verticalStackedBarChart100':
      return StackedVerticalBarChart;
    case 'number':
      return NumberChart;
    case 'pivotTable':
      return PivotChart;
    case 'scatter':
      return ScatterChart;
    case 'histogram':
      return HistogramChart;
    case 'treemap':
      return TreemapChart;
    case 'heatmap':
      return HeatmapChart;
    case 'stackedBarCombo':
      return StackedBarComboChart;
    case 'funnel':
      return FunnelChart;
    default:
      return OtherChart;
  }
}
